import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import Container from '../../../components/ui/Container';
import OptimizedImage from '../../../components/ui/OptimizedImage';
import TiltCard from '../../../components/ui/TiltCard';
import ScrollReveal from '../../../components/ui/ScrollReveal';
import SectionHeading from '../../../components/ui/SectionHeading';

const ProgramsShowcase = ({ data }) => {
  if (!data) return null;

  const cards = data.cards || [];

  return (
    <section className="py-section" style={{ backgroundColor: 'var(--color-bg-secondary)' }}>
      <Container>
        <ScrollReveal>
          <SectionHeading
            tag="What We Offer"
            title={data.title}
            subtitle={data.description}
          />
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => (
            <ScrollReveal key={i} animation="fade-up" delay={i * 0.1}>
              <TiltCard className="h-full">
                <motion.div
                  whileHover={{ y: -6 }}
                  className={`
                    relative rounded-2xl overflow-hidden glass-strong
                    border border-[var(--color-border-card)]
                    shadow-card hover:shadow-card-hover transition-all duration-300
                    h-full group
                    ${card.ctaButton ? 'pb-20' : 'pb-6'}
                  `}
                >
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: 'linear-gradient(135deg, rgba(83,150,189,0.08), transparent, rgba(100,178,255,0.08))',
                    }}
                  />
                  <div className="flex justify-center pt-8">
                    <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-md bg-white">
                      <OptimizedImage
                        src={card.image.url}
                        alt={card.image.alt}
                        className="w-full h-full"
                        wrapperClassName="w-full h-full"
                        objectFit="cover"
                        aspectRatio="1/1"
                      />
                    </div>
                  </div>
                  <div className="p-5 text-center">
                    <h3 className="text-lg font-heading font-bold mb-2 text-[var(--color-text-primary)]">
                      {card.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-[var(--color-text-secondary)]">
                      {card.description}
                    </p>
                  </div>
                  {card.ctaButton && (
                    <div className="absolute bottom-5 left-0 right-0 text-center">
                      <Link
                        to={card.ctaButton.link}
                        className="inline-flex items-center gap-1.5 px-5 py-2.5 text-sm font-semibold text-white bg-brand-500 hover:bg-brand-600 rounded-lg transition-colors"
                      >
                        {card.ctaButton.text}
                        <FiArrowRight className="w-4 h-4" />
                      </Link>
                    </div>
                  )}
                </motion.div>
              </TiltCard>
            </ScrollReveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ProgramsShowcase;
